import { createSlice } from "@reduxjs/toolkit";
// import { CategoryList, hardwareList } from "../../Components/Data";

const initialState = {
  hardware: [],
  loading: false,
  categories: [],
  cart: {
    list: [],
    subtotal: 0,
    cartqnt: 0,
    vatAmount: 0,
    vat: 0,
    finaltotal: 0,
  },
};

export const dataListsSlice = createSlice({
  name: "dataList",
  initialState,
  reducers: {
    dataListRequested: (dataList) => {
      dataList.loading = true;
    },
    dataListSucess: (dataList, action) => {
      dataList.hardware = action.payload;
      dataList.loading = false;
    },
    dataListFailure: (dataList) => {
      dataList.loading = false;
      dataList.hardware = [];
    },
    categoryRequested: (dataList) => {
      dataList.loading = true;
    },
    categorySuccess: (dataList, action) => {
      dataList.categories = action.payload;
      dataList.loading = false;
    },
    categoryFailure: (dataList) => {
      dataList.loading = false;
      dataList.categories = [];
    },
    addcart: (dataList, action) => {
      if (dataList.cart?.list?.length > 0) {
        let updatedCart = [];
        if (dataList.cart?.list?.find((e) => e?.id == action.payload?.id)) {
          updatedCart = dataList?.cart?.list.map((item, i) => {
            const prod = [...item];
            if (prod[i] == action.payload?.id) {
              prod[i] = {
                id: item?.id,
                name: item?.product_name,
                price: item?.selling_price,
                qnt: item?.qnt + 1,
                uid: item?.uid,
                image: item?.image,
                cid: item?.cid,
                vat: item?.vat,
                total: (item?.qnt + 1) * item?.selling_price,
              };
            }
            return prod;
          });
        } else {
          const proTotal =
            parseFloat(action.payload?.selling_price) *
            parseInt(action.payload?.qnt ?? 1);
          const prod = {
            id: action.payload?.id,
            name: action.payload?.product_name,
            price: action.payload?.selling_price,
            qnt: action.payload?.qnt ?? 1,
            uid: action.payload?.uid,
            image: action.payload?.image,
            cid: action.payload?.cid,
            vat: action.payload?.vat,
            total: proTotal,
          };
          const list = dataList?.cart?.list;
          updatedCart = [...list, prod];
        }
        const { subTotal, totalItem, vatCal, vatAmount } = updatedCart.reduce(
          (acc, item) => {
            const itemTotal = parseFloat(item?.total);
            const itemQnt = parseInt(item?.qnt) || 0;
            const itemVatPercent = parseFloat(item?.vat) || 0;

            const itemVatAmount = (itemTotal * itemVatPercent) / 100;

            acc.subTotal += parseFloat(itemTotal);
            acc.totalItem += itemQnt;
            acc.vatCal += itemVatPercent;
            acc.vatAmount += parseFloat(itemVatAmount);
            return acc;
          },
          { subTotal: 0, totalItem: 0, vatCal: 0, vatAmount: 0 }
        );
        const cartfinUp = {
          list: updatedCart,
          subtotal: subTotal,
          cartqnt: totalItem,
          vatAmount: vatAmount,
          vat: vatCal,
          finaltotal: subTotal + vatAmount,
        };
        dataList.cart = cartfinUp;
      } else {
        const proTotal =
          parseFloat(action.payload?.selling_price) *
          parseInt(action.payload?.qnt ?? 1);
        const prod = {
          id: action.payload?.id,
          name: action.payload?.product_name,
          price: action.payload?.selling_price,
          qnt: action.payload?.qnt ?? 1,
          uid: action.payload?.uid,
          image: action.payload?.image,
          cid: action.payload?.cid,
          vat: action.payload?.vat,
          total: proTotal,
        };

        const vatAmount = parseFloat((prod.total * prod.vat) / 100);

        const cartlist = {
          list: [prod],
          subtotal: parseFloat(prod.total),
          cartqnt: parseInt(prod.qnt),
          vat: parseFloat(prod.vat),
          vatAmount: parseFloat((prod.total * prod.vat) / 100),
          finaltotal: parseFloat(prod.total) + vatAmount,
        };
        dataList.cart = cartlist;
        // dataList.cart.push(action.payload);
      }
      dataList.loading = false;
    },
    handleqnt: (dataList, action) => {
      const updateQnt = dataList?.cart?.list?.map((item) => {
        if (item?.id === action.payload?.id) {
          if (action.payload?.qnt > 0) {
            const updatedQnt = action.payload?.qnt;
            const unitPrice = item?.total / item?.qnt || 0;
            return {
              ...item,
              qnt: updatedQnt,
              total: unitPrice * updatedQnt,
            };
          } else {
            return null; // Remove item if qnt <= 0
          }
        }
        return item;
      });

      const updateCartlist = updateQnt?.filter((e) => e != null);

      // const subTotal = updateCartlist.reduce(
      //   (acc, item) => acc + (item?.total || 0),
      //   0
      // );

      // const totalitem = updateCartlist.reduce(
      //   (acc, item) => acc + (item?.qnt || 0),
      //   0
      // );
      const { subTotal, totalItem, vatCal, vatAmount } = updateCartlist.reduce(
        (acc, item) => {
          const itemTotal = parseFloat(item?.total);
          const itemQnt = parseInt(item?.qnt) || 0;
          const itemVatPercent = parseFloat(item?.vat) || 0;

          const itemVatAmount = (itemTotal * itemVatPercent) / 100;

          acc.subTotal += parseFloat(itemTotal);
          acc.totalItem += itemQnt;
          acc.vatCal += itemVatPercent;
          acc.vatAmount += parseFloat(itemVatAmount);
          return acc;
        },
        { subTotal: 0, totalItem: 0, vatCal: 0, vatAmount: 0 }
      );

      dataList.cart = {
        list: updateCartlist,
        subtotal: subTotal,
        cartqnt: totalItem,
        vat: vatCal,
        vatAmount: vatAmount,
        finaltotal: subTotal + vatAmount,
      };
    },
    removeCart: (dataList, action) => {
      const updatecate = dataList.cart?.list.filter(
        (e) => e?.id != action.payload?.id
      );
      const { subTotal, totalItem, vatCal, vatAmount } = updatecate.reduce(
        (acc, item) => {
          const itemTotal = parseFloat(item?.total) || 0;
          const itemQnt = parseInt(item?.qnt) || 0;
          const itemVatPercent = parseFloat(item?.vat) || 0;

          const itemVatAmount = (itemTotal * itemVatPercent) / 100;

          acc.subTotal += parseFloat(itemTotal);
          acc.totalItem += itemQnt;
          acc.vatCal += itemVatPercent;
          acc.vatAmount += parseFloat(itemVatAmount);
          return acc;
        },
        { subTotal: 0, totalItem: 0, vatCal: 0, vatAmount: 0 }
      );
      const cartfinUp = {
        list: updatecate,
        subtotal: subTotal,
        cartqnt: totalItem,
        vatAmount: vatAmount,
        vat: vatCal,
        finaltotal: subTotal + vatAmount,
      };
      dataList.cart = cartfinUp;
      dataList.loading = false;
    },
    removeAllCart: (dataList) => {
      dataList.cart = {
        list: [],
        subtotal: 0,
        cartqnt: 0,
        vatAmount: 0,
        finaltotal: 0,
        vat: 0,
      };
      dataList.loading = false;
    },
  },
});

export const {
  dataListRequested,
  dataListSucess,
  dataListFailure,
  addcart,
  removeCart,
  removeAllCart,
  categoryRequested,
  categorySuccess,
  categoryFailure,
  handleqnt,
} = dataListsSlice.actions;

export default dataListsSlice.reducer;
